export default __webpack_public_path__ + "static/media/014.033c8134.jpg";